export const MenuItems = [
  {
    title: 'About us',
    path: '/about-us',
    cName: 'dropdown-link'
  },
  {
    title: 'Promotion',
    path: '/promotion',
    cName: 'dropdown-link'
  },
  {
    title: 'Design',
    path: '/design',
    cName: 'dropdown-link'
  },
  {
    title: 'Development',
    path: '/development',
    cName: 'dropdown-link'
  }
];
